export default __webpack_public_path__ + "static/media/gallery_03.a44812a1.jpg";